import LendingTermSettings from "@/models/Products/ProductSettings/DefaultSettings/Term/LendingTermSettings";
import CurrencyUtils from "@/lib/currencyUtils";

export default class UpdateLendingTermSettingsRequest extends LendingTermSettings {
    updatedAt: Date;

    public constructor(settings: LendingTermSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.enabled = settings.enabled;
            this.termPeriodType = settings.termPeriodType;
            this.termPeriodValue = settings.termPeriodValue;
            this.termPeriodValue = +this.termPeriodValue
            this.amount.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.amount.amount);
            this.amount.currency = defaultWalletCurrency;
            this.amountMinimum.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.amountMinimum.amount);
            this.amountMinimum.currency = defaultWalletCurrency;
            this.amountMaximum.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.amountMaximum.amount);
            this.amountMaximum.currency = defaultWalletCurrency;
            this.scheduleType = settings.scheduleType;
        }
    }
}